{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Accenti e personaggi speciali",
  "account": "Account",
  "activity": "Attività",
  "actor": "Attore {{number}}",
  "actor_2": "Attore 2",
  "actor_name": "Nome dell'attore",
  "actor_voice": "Voce dell'attore",
  "add_alternatives": "Aggiungi alternative",
  "add_another_reply": "Aggiungi un'altra risposta",
  "add_courses": "Aggiungi corsi",
  "add_answer": "Aggiungi risposta",
  "add_image": "Aggiungi immagine",
  "add_image_desc": "Aggiungi un'immagine al tuo allenamento!",
  "add_link": "Aggiungi collegamento",
  "add_link_desc": "Aggiungi un link al tuo allenamento!",
  "all_steps_complete": "Tutti i passaggi completati",
  "alternative_versions": "Versioni alternative",
  "archive_recording_error": "Si è verificato un problema durante l'archiviazione della registrazione",
  "assign": "Assegna",
  "attach_file": "Allega file",
  "bot_not_found": "Chatbot non trovato",
  "bot_not_found_desc": "Non abbiamo trovato questo chatbot. Potrebbe essere stato eliminato o reso privato.",
  "categories": "Categorie",
  "chart": "Grafico",
  "choose_length_of_roleplay": "Scegli la lunghezza dello scenario",
  "clear": "Cancella",
  "close_pdf": "Chiudi PDF",
  "comma_seperated_domains": "Domini separati da virgole",
  "community": "Comunità",
  "datetime": "Data e ora",
  "days": "giorni",
  "days_late": "{{count}} giorni di ritardo",
  "discussion": "Discussione",
  "download_error": "Si è verificato un problema durante il download del file",
  "editor_mode": "Modalità editor",
  "email_notifications": "Notifiche email",
  "enter_linguistic_goal": "Inserisci il tuo obiettivo linguistico",
  "add_new": "Aggiungere nuova",
  "add_phrase": "Aggiungi frase",
  "add_phrase_desc": "Aggiungi una nuova frase {{language}} che le persone possano imparare",
  "add_phrases": "Aggiungi frasi",
  "add_phrases_to_enable_exercise": "Aggiungi frasi per abilitare l'esercizio",
  "add_question": "Aggiungi domanda",
  "add_question_desc": "Poni una domanda di comprensione. La domanda può avere più risposte corrette.",
  "add_review": "Aggiungi recensione",
  "add_review_desc": "Condividi i tuoi pensieri qui sotto",
  "add_script": "Aggiungi Script",
  "add_section": "Aggiungi sezione",
  "add_substitution": "Aggiungi sostituzione",
  "add_substitution_desc": "Con le sostituzioni, puoi fare in modo che 'ciò che è' sia espanso in 'ciò che è' invece, permettendoti un migliore controllo su come rispondi al messaggio dell'utente!",
  "add_topic": "Aggiungi argomento",
  "add_topic_desc": "Gli argomenti sono raggruppamenti logici di trigger. Quando un utente si trova in un argomento, può solo abbinare i trigger che appartengono a quell'argomento.",
  "add_topic_to_section": "Aggiungi argomento alla sezione {{sectionId}}",
  "add_trigger": "Aggiungi trigger",
  "add_trigger_desc": "Un trigger è una riga di testo utilizzata per abbinare il messaggio dell'utente.",
  "add_variable": "Aggiungi variabile",
  "add_variable_desc": "Le variabili del chatbot sono informazioni che descrivono il tuo chatbot. Con le variabili del chatbot, possiamo scrivere risposte in cui il chatbot può dire all'utente qualcosa su se stesso.",
  "add_voice": "Aggiungi voce",
  "all": "Tutti",
  "all_topics_completed": "Tutti gli argomenti completati",
  "alternatives": "alternative",
  "alternatives_desc": "Un elenco di parole o frasi che possono essere riutilizzate nel tuo chatbot.",
  "alternatives_name": "Nome",
  "alternatives_value": "Elenco di parole (separati da virgola)",
  "answer": "Risposta",
  "new_answer_placeholder": "Scrivi qui la tua risposta",
  "answer_message_100": "Perfetto, ottimo lavoro",
  "answer_message_90": "Ci stai arrivando, continua a provare",
  "answer_message_95": "Quello era vicino, ci sei quasi",
  "answer_message_wrong": "Non era del tutto giusto",
  "attempt": "Tentativo",
  "attempt_messages": "Tentativo di Esercizio",
  "attempt_table": "Tentativi",
  "auto_translate": "Traduzione automatica",
  "auto_translate_phrase": "Traduzione automatica frase",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2",
  "back": "Indietro",
  "back_to_course": "Torna al corso",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Ascolta e Parla",
  "all_modes": "Tutte le modalità",
  "bot_intro_message": "Messaggio di introduzione al chatbot",
  "bot_intro_message_helper_text": "Lascia vuoto se vuoi che lo studente inizi la conversazione.",
  "bot_information": "Informazioni sui chatbot",
  "bot_name": "Nome del chatbot",
  "bot_reply": "Risposta Chatbot",
  "bot_settings": "Impostazioni del chatbot",
  "bot_title": "Titolo del chatbot",
  "bot_voice": "Voce chatbot",
  "bots": "Chatbots",
  "bots_not_found_desc": "Crea il primo chatbot oggi",
  "bots_not_found_title": "Nessun chatbot trovato",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Annulla",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Cambia i colori delle app",
  "change_language": "Cambia lingua",
  "chatbot_exercise_desc": "Chatta con un chatbot per simulare una conversazione su un argomento",
  "chatbots": "Robot di chat",
  "choose_avatar": "Selezionare Nuala",
  "choose_from_file": "Selezionare dal file",
  "classroom_code": "Codice di classe",
  "classroom_code_label": "Inserisci il codice della classe",
  "classroom_code_not_valid": "Codice della classe non valido",
  "classroom_created": "Classe creata",
  "classroom_deleted": "Aula eliminata",
  "classroom_information": "Informazioni sull'aula",
  "classroom_name": "Nome della classe",
  "classroom_not_found": "Aula non trovata",
  "classroom_not_found_desc": "Questa classe potrebbe essere stata eliminata",
  "classroom_load_error": "Impossibile caricare questa classe",
  "classroom_load_error_desc": "Si è verificato un errore durante il caricamento di questa classe. Riprova.",
  "classroom_settings": "Impostazioni della classe",
  "classrooms": "aule",
  "classrooms_not_found_desc": "Crea la prima classe oggi",
  "classrooms_not_found_title": "Nessuna classe trovata",
  "collaborators": "collaboratori",
  "color": "Colore",
  "community_templates": "Modelli di comunità",
  "completed": "Completato",
  "completed_icon": "Icona completata",
  "completion": "Completamento",
  "completions": "Completamenti",
  "confirmation": "Conferma",
  "contact_form": "Modulo di Contatto",
  "continue": "Continua",
  "continue_exercise": "Continua l'esercizio",
  "continue_learning": "Continua l'apprendimento",
  "continue_teaching": "Continua a insegnare",
  "copied": "Copiato",
  "copy_to_clipboard": "Copia negli appunti",
  "correct": "Corretta",
  "correct_answer": "Risposta corretta",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Course",
  "course_code": "Codice del corso",
  "course_code_label": "Inserisci il codice del corso",
  "course_code_not_valid": "Codice del corso non valido",
  "course_created": "Corso creato",
  "course_deleted": "Corso cancellato",
  "course_information": "Informazioni sul corso",
  "course_name": "Nome del corso",
  "course_not_found": "Corso non trovato",
  "course_not_found_desc": "Questo corso potrebbe essere stato cancellato",
  "course_outline": "Struttura del corso",
  "course_progress": "Progresso del corso",
  "course_settings": "Impostazioni del corso",
  "courses": "corsi",
  "courses_not_found_desc": "Crea il primo corso oggi",
  "courses_not_found_title": "Nessun corso trovato",
  "create": "Creare",
  "create_bot": "Crea chatbot",
  "create_classroom": "Crea un'aula",
  "create_course": "Crea corso",
  "create_course_section": "Crea la sezione del corso",
  "create_course_section_desc": "Sta a te come strutturare il corso, le strutture di esempio sono 'Principiante, Intermedio, Avanzato' o 'Settimana 1, Settimana 2, Settimana 3'",
  "create_topic": "Crea argomento",
  "created_courses": "Corsi creati",
  "creation_visibility": "I contenuti pubblici possono essere utilizzati come punto di partenza per le creazioni di altri docenti.",
  "creator": "Creatore",
  "customization": "Personalizzazione",
  "dark_theme": "Tema scuro",
  "dark_theme_desc": "Rende scure le superfici chiare della pagina, creando un'esperienza ideale per la notte.",
  "delete_bot": "Elimina Chatbot",
  "delete_bot_confirmation": "Sei sicuro di voler eliminare questo chatbot?",
  "delete_classroom": "Elimina classe",
  "delete_classroom_confirmation": "Sei sicuro di voler eliminare questa classe?",
  "delete_course": "Elimina corso",
  "delete_course_confirmation": "Sei sicuro di voler eliminare questo corso?",
  "delete_phrase": "Elimina frase",
  "delete_phrase_confirmation": "Sei sicuro di voler eliminare questa frase?",
  "delete_review": "Elimina recensione",
  "delete_review_confirmation": "Sei sicuro di voler eliminare la tua recensione?",
  "delete_roleplay": "Elimina gioco di ruolo",
  "delete_roleplay_confirmation": "Sei sicuro di voler eliminare questo gioco di ruolo?",
  "delete_section": "Elimina sezione",
  "delete_section_confirmation": "Sei sicuro di voler eliminare questa sezione?",
  "delete_topic": "Elimina argomento",
  "delete_topic_confirmation": "Sei sicuro di voler eliminare questo argomento?",
  "description": "Descrizione",
  "difficulty": "Difficoltà",
  "difficulties": "Difficoltà",
  "disable": "disattivare",
  "disabled": "Disabilitato",
  "display": "Schermo",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Scarica",
  "drop_csv_file_or_click_to_upload": "Rilascia il file CSV o fai clic per caricare.",
  "edit": "modificare",
  "edit_bot": "Modifica Chatbot",
  "edit_discussion": "Modifica discussione",
  "edit_roleplay": "Modifica gioco di ruolo",
  "email": "E-mail",
  "enable": "Abilitare",
  "enabled": "Abilitato",
  "enrolment_key": "Chiave di iscrizione",
  "enrolment_key_not_valid": "Chiave di iscrizione non valida",
  "enter_private_key": "Inserisci la chiave privata",
  "error_generating_discussion": "Si è verificato un problema durante la generazione della discussione",
  "exercise": "Esercizio",
  "exercise_complete": "Esercizio completo",
  "exercise_completed_icon": "{{name}} completato {{counter}} volta",
  "exercise_completion": "ha completato l'esercizio di {{exercise}} '{{id}}'",
  "exercise_in_progress": "ha iniziato l'esercizio di {{exercise}} '{{id}}'",
  "exercise_info": "Informazioni sull'allenamento",
  "exercise_no_longer_available": "Questo esercizio non è più disponibile",
  "exercises": "esercizi",
  "exercises_completed": "Esercizi completati",
  "exercises_completed_icon": "{{name}} completato {{counter}} volte",
  "exit": "Esci",
  "expand": "Espandi",
  "fill_in_contact_form": "Compila il modulo sottostante",
  "find_bot": "Trova il chatbot",
  "find_classroom": "Trova l'aula",
  "find_course": "Trova corso",
  "find_roleplay": "Trova il gioco di ruolo",
  "finish": "finire",
  "finish_exercise": "Finire esercizio",
  "for_lang": "io parlo",
  "formatting_options": "Opzioni di formattazione",
  "from": "A partire dal",
  "fullscreen": "Schermo intero",
  "generate_definitions_info": "Genera definizioni per le frasi di questo elenco.",
  "generating": "Generazione in corso",
  "get_started": "Iniziare",
  "go_back": "Torna indietro",
  "go_back_to_topic": "Torna All'argomento",
  "go_to": "Go to",
  "go_to_settings": "Vai alle impostazioni",
  "group_information_form_title": "Parlaci del tuo gruppo",
  "group_member_limit": "Limite di membri del gruppo",
  "group_name": "Nome del gruppo",
  "group_picture": "Immagine del gruppo",
  "group_subscription_form_title": "Configura l'abbonamento del gruppo",
  "help": "Aiuto",
  "hidden": "Nascosto",
  "hide": "Nascondi",
  "hide_bot": "Nascondi chatbot",
  "hide_chatbots_exercise": "Nascondi i robot",
  "hide_listening_exercise": "Nascondi l'esercizio di ascolto",
  "hide_menu": "Nascondi menu",
  "hide_options": "Nascondi opzioni",
  "hide_pronunciation_exercise": "Nascondi l'esercizio della pronuncia",
  "hide_roleplay": "Nascondi il gioco di ruolo",
  "hide_roleplays_exercise": "Nascondi i Roleplay",
  "hide_section": "Sezione nascosta",
  "hide_topic": "Nascondi argomento",
  "hide_translation_exercise": "Nascondi l'esercizio di traduzione",
  "hide_word_bank": "Nascondi banca di parole",
  "home": "Casa",
  "how_to_join_find_button": "Cerca il pulsante {{button}} e fai clic su di esso.",
  "how_to_join_get_ready": "Preparati a giocare.",
  "how_to_join_intro": "Per partecipare alla partita, segui questi passaggi:",
  "how_to_join_open_classroom": "Apri la classe {{classroom}} o scansiona il suo codice QR qui sotto",
  "how_to_join_sign_in": "Accedi al tuo account.",
  "how_to_join_title": "Come partecipare alla partita",
  "in_game": "In partita",
  "in_progress": "Continua a giocare",
  "incorrect": "scorretto",
  "insert_bold": "Inserisci grassetto",
  "insert_italic": "Inserisci corsivo",
  "insert_link": "Inserisci link",
  "insert_photo": "Inserisci foto",
  "instruction_message": "Istruzioni",
  "join": "Aderire",
  "join_classroom": "Iscriviti a Classroom",
  "join_code_desc": "Gli studenti possono utilizzare il codice seguente per aderire",
  "join_course": "Iscriviti al corso",
  "join_date": "Data di Iscrizione",
  "joined": "Iscritto",
  "joined_classroom": "Entrato in aula",
  "joined_course": "Entrato nel corso",
  "language": "linguaggio",
  "language_phrase": "Frase {{language}}",
  "language_translation": "Traduzione {{language}}",
  "learn": "Imparare",
  "learn_for_speakers_of": "{{learnLang}} per {{forLang}} relatori",
  "learn_lang": "Voglio imparare",
  "leave_classroom": "Abbandonare l'aula",
  "leave_classroom_confirmation": "Sei sicuro di voler eliminare questa classe?",
  "leave_course": "Lascia il corso",
  "leave_course_confirmation": "Sei sicuro di voler lasciare questo corso?",
  "left_classroom": "Ha abbandonato l'aula",
  "left_course": "Ha abbandonato corso",
  "lets_begin": "Cominciamo",
  "library": "Biblioteca",
  "link_name": "Nome del link",
  "link_name_helper_text": "Inserisci un nome visualizzato per il tuo link",
  "link_value": "Link Url",
  "link_value_helper_text": "Inserisci l'URL per il tuo link",
  "listen_to_this_phrase": "Ascolta questa frase {{language}}",
  "listener_dialog_desc": "Selezionare una voce qui sotto per ascoltare la pronuncia",
  "listening": "Ascoltando",
  "listening_exercise_desc": "Puoi prendere ciò che viene detto?",
  "load_more_events": "Carica più eventi",
  "loading": "Caricamento",
  "loading_topics": "Caricamento degli argomenti",
  "logout": "Disconnettersi",
  "manage_course": "Gestisci corso",
  "members": "Studenti",
  "members_not_found": "Nessun membro",
  "members_not_found_desc": "Nessun membro trovato",
  "message": "Messaggio",
  "method": "Metodo",
  "missing_details": "Dettagli mancanti",
  "more_definitions": "Altre definizioni",
  "more_options": "Più opzioni",
  "more_translations": "Altre traduzioni",
  "my_courses": "I miei corsi",
  "name": "Nome",
  "new": "Nuovo",
  "next": "Il prossimo",
  "next_with_progress": "Il prossimo ({current} di {total})",
  "no_activity_found": "Nessuna attività trovata",
  "no_chatbot_templates": "Nessun modello disponibile",
  "no_courses_found": "Nessun corso trovato",
  "no_phrases": "Nessuna frase",
  "no_topics_available": "Nessun argomento disponibile",
  "not_in_game": "Fuori partita",
  "nualang_templates": "Modelli",
  "nudge_add_family_name_field_desc": "Aggiungi il tuo cognome così i docenti potranno identificarti.",
  "nudge_add_family_name_profile_desc": "Aggiungi il tuo cognome al profilo così i docenti potranno identificarti.",
  "nudge_add_family_name_title": "Aggiungi il tuo cognome",
  "on": "il",
  "only_available_on_chrome": "Disponibile solo su Chrome",
  "open_image_library": "Apri la libreria di immagini",
  "open_in_google_sheets": "Apri in Google Sheets",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Opzionale",
  "or_choose_from_one_of_the_following": "Oppure selezionare una delle seguenti opzioni",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "Perfetto! Fai clic su Fine per creare il tuo gruppo.",
  "phrase": "frase",
  "phrase_group_game_in_progress_icon": "{{name}} in corso",
  "phrase_lists_error": "Si è verificato un problema durante il caricamento degli elenchi di frasi",
  "phrases": "frasi",
  "player": "giocatore",
  "players": "giocatori",
  "plays": "{{number}} Ascolti",
  "please_select_a_textfield": "Seleziona un campo di testo",
  "popular_courses": "Corsi popolari",
  "preview": "Anteprima",
  "preview_pdf": "Anteprima PDF",
  "previous": "Precedente",
  "print": "Stampa",
  "private": "Privato",
  "problem": "C'era un problema",
  "problem_creating": "Si è verificato un problema durante la creazione",
  "problem_deleting": "Si è verificato un problema durante l'eliminazione",
  "problem_getting_reply": "Si è verificato un problema durante la risposta",
  "problem_loading": "Si è verificato un problema durante il caricamento",
  "problem_sending_contact_form": "Problema durante l'invio del modulo di contatto",
  "profile": "Profilo",
  "profiles": "Profili",
  "progress_icon": "Icona di avanzamento",
  "pronounce_this_phrase": "Pronuncia questa frase",
  "pronunciation": "Pronuncia",
  "pronunciation_exercise_desc": "Esercitati a pronunciare frasi",
  "public": "Pubblico",
  "question": "Domanda",
  "new_question_placeholder": "Scrivi qui la tua domanda",
  "questions": "Domande",
  "quit": "Uscire",
  "recommended": "Consigliato",
  "record_message": "Registra messaggio",
  "record_unsupported": "La registrazione non è supportata in questo browser",
  "records": "Documenti",
  "redo_action": "Rifare",
  "refresh": "Aggiorna",
  "remove": "Rimuovere",
  "remove_bot": "Rimuovi Chatbot",
  "remove_card": "Remove Card",
  "remove_roleplay": "Rimuovi gioco di ruolo",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "rispondere",
  "reply_options": "Opzioni di risposta",
  "reply_options_are_disabled": "Le opzioni di risposta sono disabilitate",
  "reply_options_desc": "Consenti agli studenti di selezionare la risposta corretta da un elenco di opzioni",
  "report_views": "Views",
  "required_for_private_classrooms": "Richiesto per aule private",
  "required_for_private_courses": "Richiesto per corsi privati",
  "reset": "Ripristina",
  "restart_exercise": "Riavvia esercizio",
  "result": "Risultato",
  "retry": "Riprova",
  "return_to_course": "Ritorna al corso",
  "review_content": "Rivedi il contenuto",
  "review_title": "titolo della recensione",
  "reviews": "Recensioni",
  "reviews_not_found": "Nessuna recensione",
  "reviews_not_found_desc": "Nessuna recensione trovata",
  "roleplay": "Gioco di ruolo",
  "roleplay_exercise_desc": "Simula e rispondi alle domande sulle conversazioni tra due persone",
  "roleplay_not_found": "Scenario non trovato",
  "roleplay_not_found_desc": "Non abbiamo trovato questo scenario. Potrebbe essere stato eliminato o reso privato.",
  "roleplays_not_found_desc": "Prova a modificare i parametri di ricerca",
  "roleplay_information": "Informazioni di gioco",
  "roleplay_name": "Nome del gioco",
  "roleplay_settings": "Impostazioni di gioco",
  "roleplays": "Roleplay",
  "save_changes": "Salvare le modifiche",
  "save_definitions_error": "Si è verificato un problema durante il salvataggio delle definizioni",
  "save_progress": "Salva Progressi",
  "scenarios": "Scenari",
  "schedule": "Pianifica",
  "script_not_found": "Copione non trovato",
  "script_not_found_desc": "Non abbiamo trovato questo copione. Potrebbe essere stato eliminato o reso privato.",
  "search_images": "Cerca immagini",
  "see_more_pronunciations": "Vedi altre pronunce",
  "send": "Invia",
  "show_phrase_list": "Mostra elenco di frasi",
  "show_progress": "Mostra progressi",
  "script": "script",
  "search": "cercare",
  "search_for_student": "Cerca studente",
  "section": "Sezione",
  "section_name": "Nome della sezione",
  "sections_not_found": "Nessuna sezione trovata",
  "sections_not_found_desc": "",
  "select_a_template": "Seleziona un modello",
  "select_file": "Seleziona il file",
  "select_file_desc": "Trascina qui il file o fai clic per sfogliare il tuo computer",
  "select_files": "Seleziona i file",
  "select_the_from_date": "Seleziona la data di inizio",
  "select_the_to_date": "Seleziona la data fino ad oggi",
  "settings": "impostazioni",
  "share": "Condividere",
  "share_via": "Condividere tramite",
  "show_bot": "Mostra chatbot",
  "show_chatbots_exercise": "Mostra i robot",
  "show_listening_exercise": "Mostra esercizio di ascolto",
  "show_menu": "Mostra menu",
  "show_options": "Mostra opzioni",
  "show_pronunciation_exercise": "Mostra esercizio di pronuncia",
  "show_roleplay": "Mostra gioco di ruolo",
  "show_roleplays_exercise": "Mostra Roleplay",
  "show_section": "Mostra sezione",
  "show_topic": "Mostra argomento",
  "show_translation_exercise": "Mostra esercizio di traduzione",
  "skip": "Salta",
  "skip_copy_topic": "Salta",
  "speakers_of": "parlante di",
  "start": "Comincia",
  "start_course": "Comincia il corso",
  "stop": "Fermare",
  "stop_recording": "Ferma la registrazione",
  "student_instructions": "Istruzioni per gli studenti",
  "student_instructions_placeholder": "Istruzioni per lo studente:\nPuoi aggiungere il tuo messaggio di istruzioni formattato qui \n\ne.g. \"Benvenuto nel chatbot, puoi iniziare digitando ciao \"",
  "student_limit": "Limite di studenti",
  "submit": "Invia",
  "submitting": "Invio in corso",
  "subscription": "Abbonamento",
  "subscription_period_end": "Fine del periodo di abbonamento",
  "subscription_status": "Stato dell'abbonamento",
  "substitution_desc": "Apporta modifiche al messaggio dell'utente prima di controllare i trigger.",
  "subject": "Soggetto",
  "substitution_name": "Testo originale",
  "substitution_name_helper_text": "Il testo originale che può apparire nel messaggio dell'utente",
  "substitution_value": "Testo di sostituzione",
  "substitution_value_helper_text": "Non deve contenere simboli o punteggiatura speciali e deve anche essere minuscolo",
  "substitutions": "sostituzioni",
  "table": "Tabella",
  "thank_you_for_submitting": "Grazie per l'invio, ti contatteremo al più presto. Tornando alla home page",
  "the_default_topic_is_random": "L'argomento predefinito è casuale",
  "to": "Per",
  "toggle_theme": "Attiva / disattiva il tema chiaro / scuro",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Argomento",
  "topic_code": "Codice argomento",
  "topic_desc": "Quando un utente si trova in un argomento, può solo abbinare i trigger che appartengono a quell'argomento.",
  "topic_image": "Immagine dell'argomento",
  "topic_information": "Informazioni sull'argomento",
  "topic_name": "Nome dell'argomento",
  "topic_not_found": "Argomento non trovato",
  "topic_not_found_desc": "Questo argomento potrebbe essere stato eliminato",
  "topics": "Temi",
  "translate": "Tradurre",
  "translate_is_disabled": "La traduzione è disabilitata",
  "translate_this_phrase": "Traduci questa frase",
  "translation": "Traduzione",
  "translation_exercise_desc": "Metti alla prova le tue abilità linguistiche traducendo frasi",
  "translations": "Traduzioni",
  "trigger_value": "Attiva il testo",
  "trigger_value_helper_text": "Non deve contenere simboli o punteggiatura speciali e deve anche essere minuscolo",
  "triggers": "trigger",
  "triggers_desc": "Un trigger è una riga di testo utilizzata per abbinare il messaggio dell'utente.",
  "type": "Genere",
  "unarchive": "Rimuovi dall'archivio",
  "undo_action": "annullare l'azione",
  "update": "Aggiornare",
  "update_image": "Aggiorna immagine",
  "update_link": "Aggiorna link",
  "update_phrase": "Frase di aggiornamento",
  "update_phrase_desc": "Apporta modifiche a questa frase esistente",
  "update_picture": "Aggiorna immagine",
  "update_question": "Domanda di aggiornamento",
  "update_question_desc": "Poni una domanda di comprensione. La domanda può avere più risposte corrette.",
  "update_recording_error": "Si è verificato un problema durante l'aggiornamento della registrazione",
  "update_review": "Recensione di aggiornamento",
  "update_review_desc": "Descrizione della recensione di aggiornamento",
  "update_section": "Sezione di aggiornamento",
  "update_section_desc": "Sta a te come strutturare il corso, le strutture di esempio sono 'Principiante, Intermedio, Avanzato' o 'Settimana 1, Settimana 2, Settimana 3'",
  "update_substitution": "Sostituzione di aggiornamento",
  "update_topic": "Argomento di aggiornamento",
  "update_trigger": "Trigger di aggiornamento",
  "update_variable": "Aggiorna variabile",
  "upgrade": "Passa a un piano superiore",
  "upload_phrases": "Carica frasi",
  "upload_phrases_desc": "Crea e carica un file CSV come nell'esempio seguente.",
  "upload_phrases_example_phrase_1": "ciao",
  "upload_phrases_example_phrase_2": "arrivederci",
  "upload_phrases_example_phrase_3": "mi chiamo",
  "upload_phrases_example_definition_1": "Una parola usata per salutare qualcuno",
  "upload_phrases_example_definition_2": "Una parola usata quando si lascia qualcuno",
  "upload_phrases_example_definition_3": "Una frase usata per dire il proprio nome",
  "upload_script": "Carica Script",
  "upload_script_desc": "Carica uno script di gioco di ruolo con un file csv utilizzando il formato mostrato di seguito",
  "use_keyboard": "Usa la tastiera",
  "use_word_bank": "Usa banca di parole",
  "user_message": "Messaggio dell'utente",
  "user_updated": "Utente aggiornato",
  "variable_desc": "Informazioni che possono essere utilizzate nel tuo chatbot.",
  "variable_name": "Nome della variabile",
  "variable_value": "Valore variabile",
  "variables": "variabili",
  "vars": "Variabili",
  "view_activity": "Visualizza attività",
  "view_instruction_message": "Visualizza le istruzioni",
  "view_outline": "Visualizza struttura",
  "view_progress": "Visualizza progresso",
  "visibility": "Visibilità",
  "visit_learning_site": "Visita il Learning Site",
  "voice_speed_disabled": "La velocità della voce non è disponibile per questa voce",
  "weekly_progress": "Progressi settimanali",
  "what_do_you_hear": "Cosa senti?",
  "answer_method": "Metodo di risposta",
  "answers": "Risposte",
  "attempt_info": "Informazioni sul tentativo",
  "bot_outputs": "Uscite del chatbot",
  "creator_instructions": "Istruzioni per l'insegnante",
  "creator_instructions_placeholder": "Puoi aggiungere un messaggio di istruzioni formattato per un collaboratore del corso qui, ad es. Benvenuto nel chatbot, ecco come personalizzare per i tuoi studenti ...",
  "date": "Data",
  "fri": "venerdì",
  "listener": "Ascoltatore",
  "mon": "lunedì",
  "new_bots": "Nuovi chatbot",
  "new_courses": "Nuovi corsi",
  "new_roleplays": "Nuovi Roleplay",
  "no_results_found": "nessun risultato trovato",
  "option": "Opzione",
  "play_again": "Gioca di nuovo",
  "role_played": "Ruolo interpretato",
  "sat": "sabato",
  "show_word_bank": "Mostra banca di parole",
  "skipped": "Saltato",
  "speak": "Parlare",
  "sun": "Sole",
  "text": "Testo",
  "thu": "giovedì",
  "time": "Tempo",
  "time_spent": "Tempo impiegato",
  "tue": "martedì",
  "view_report": "Visualizza rapporto",
  "voice": "Voce",
  "wed": "mercoledì",
  "word_bank": "Banca di parole",
  "teach": "Insegnare",
  "active_now": "Attivo ora",
  "manage_classroom": "Gestire Aula",
  "must_question_least_correct_answer": "Deve essere almeno una domanda e una risposta corretta.",
  "enter_name_your_voice_clip": "Inserisci un nome per la tua clip vocale?",
  "my_unnamed_clip": "La mia clip senza nome",
  "are_you_sure": "Sei sicuro?",
  "is_already_created_variable_overwrite": "è già una variabile creata, vuoi sovrascriverla?",
  "is_already_created_substitution_overwrite": "è già una sostituzione creata, vuoi sovrascriverla?",
  "is_already_created_alternative_overwrite": "è già un'alternativa creata, vuoi sovrascriverla?",
  "is_already_created_topic_overwrite": "è già un argomento creato, vuoi sovrascriverlo?",
  "bring_your_bot_picture_name": "Dai vita al tuo chatbot assegnandogli un'immagine e un nome",
  "perfect_click_finish_create_bot": "Perfetto, fai clic su Fine per creare il tuo nuovo chatbot",
  "lets_start_with_some_information_about_your_bot": "Cominciamo con alcune informazioni sul tuo chatbot",
  "lets_start_some_information_about_classroom": "Cominciamo con alcune informazioni sulla tua classe",
  "the_language_classroom_teach": "La lingua che questa classe insegnerà",
  "the_language_students_classroom_speak": "La lingua parlata dagli studenti di questa classe",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limita l'accesso alla tua classe impostando la visibilità su privato e includendo una chiave di registrazione",
  "add_collaborators": "Aggiungi collaboratori",
  "perfect_click_finish_create_classroom": "Perfetto, fai clic su Fine per creare la tua nuova classe",
  "perfect_click_finish_create_course": "Perfetto, fai clic su Fine per creare il tuo nuovo corso",
  "lets_start_information_about_course": "Cominciamo con alcune informazioni sul tuo corso",
  "the_language_course_teach": "La lingua insegnata da questo corso",
  "the_language_students_course_speak": "La lingua parlata dagli studenti di questo corso",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limita l'accesso al tuo corso impostando la visibilità su privato e includendo una chiave di iscrizione",
  "selected": "Selezionato",
  "perfect_click_finish_create_roleplay": "Perfetto, fai clic su Fine per creare il tuo nuovo gioco di ruolo",
  "lets_start_with_information_about_roleplay": "Cominciamo con alcune informazioni sul tuo gioco di ruolo",
  "invite": "Invitare",
  "topic_settings": "Impostazioni argomento",
  "topic_title": "Topic Title",
  "unanswered_table": "Senza risposta",
  "create_roleplay": "Crea un gioco di ruolo",
  "roleplays_not_found_title": "Roleplay non trovati",
  "play": "Giocare",
  "delete": "Elimina",
  "delete_picture": "Elimina immagine",
  "use_wordbank_if_stuck": "Usa la banca di parole se hai bisogno di aiuto",
  "play_bot_error": "Ops! Si è verificato un problema con il chatbot, riprova",
  "bot_editor_preview_error": "C'è stato un errore. Visita https://nualang.com/guides/create-a-bot per una guida sulla creazione di un chatbot",
  "manage_courses": "Gestire i corsi",
  "refresh_courses": "Aggiorna i corsi",
  "customize_appearance_of_course": "Personalizza l'aspetto del corso",
  "customize_appearance_of_classroom": "Personalizza l'aspetto della classe",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Crea duplicato",
  "section_visibility": "Visibilità della sezione",
  "choose_a_language": "Selezionare una lingua",
  "play_bot": "Gioca a chatbot",
  "lets_find_a_template": "Troviamo un modello!",
  "search_by_difficulty": "Cerca per difficoltà",
  "search_using_keywords": "Cerca utilizzando parole chiave",
  "select_a_nualang_template": "Seleziona un modello Nualang",
  "select_a_nualang_template_desc": "Modelli creati dal team di Nualang per aiutarti a iniziare.",
  "or_select_a_community_template": "Oppure seleziona un modello di community",
  "or_select_a_community_template_desc": "I modelli della community sono creati da insegnanti di tutto il mondo.",
  "dashboard_welcome": "Benvenuto, {{name}}!",
  "dashboard_welcome_desc": "Acquisisci familiarità con la dashboard, ecco alcuni modi per iniziare.",
  "enter_course_code": "Inserisci un codice del corso",
  "enter_course_code_desc": "Se hai un codice del corso, inseriscilo qui.",
  "enter_classroom_code": "Inserisci un codice per la classe",
  "enter_classroom_code_desc": "Se hai un codice di classe, inseriscilo qui.",
  "search_nualang": "Esplora Nualang",
  "search_nualang_desc": "C'è una crescente comunità di insegnanti che la pensano allo stesso modo che sviluppano conversazioni con i nostri Nualas, quindi c'è sempre qualcosa di nuovo da imparare.",
  "create_nualang": "Crea il tuo",
  "create_nualang_desc": "Crea conversazioni e lezioni di lingua.",
  "roleplay_editor_welcome": "Iniziare con l'Editor dei Roleplay",
  "roleplay_editor_options": "Seleziona un'opzione",
  "roleplay_editor_options_desc": "Selezionare un'opzione per aggiungere una nuova riga o aggiungi una domanda di comprensione.",
  "roleplay_editor_share": "Condividi il gioco di ruolo",
  "roleplay_editor_play": "Gioca a un gioco di ruolo",
  "bot_editor_welcome": "Iniziare con l'Editor dei chatbot",
  "bot_editor_sidebar": "Barra laterale dell'editor",
  "bot_editor_sidebar_desc": "La barra laterale è dove potrai apportare modifiche al tuo chatbot.",
  "bot_editor_flow_chart": "Flusso del chatbot",
  "bot_editor_flow_chart_desc": "Il flusso del chatbot mostra una panoramica del tuo chatbot e fornisce un'anteprima di come apparirà ogni messaggio.",
  "bot_editor_share": "Condividi chatbot",
  "bot_editor_play": "Gioca a chatbot",
  "play_roleplay": "Gioca a Roleplay",
  "delete_script_item": "Elimina elemento dallo script",
  "delete_script_item_confirmation": "Sei sicuro di voler eliminare questo elemento dallo script?",
  "add_message": "Aggiungi un messaggio",
  "resources": "Risorse",
  "contact": "Contatto",
  "sign_in": "Accesso",
  "sign_up": "Iscriviti",
  "faqs": "Domande frequenti",
  "guides": "Tutorial",
  "back_to_app": "Torna all'app",
  "notes": "Note",
  "notes_placeholder": "Inserisci note qui",
  "get_in_touch": "Contattaci",
  "get_in_touch_desc": "Hai domande o commenti? Inviaci un messaggio.",
  "avatar_generator": "Avatar Generator",
  "avatar_generator_desc": "Crea il tuo avatar personale",
  "upload_image": "Carica immagine",
  "upload_image_desc": "Trascina e rilascia l'immagine dal tuo computer",
  "random": "Random",
  "done": "Fatto",
  "file_size_exceeded": "Immagine troppo grande! Carica un'immagine più piccola di ",
  "image_selection_failed": "Non è stato possibile caricare questa immagine. Provane un'altra o carica la tua.",
  "remove_course": "Rimuovi corso",
  "courses_joined": "Corsi aderiti",
  "classroom_courses_not_found_title": "Nessun corso ancora",
  "classroom_courses_not_found_desc": "Questa classe non ha ancora corsi.",
  "in_progress_activity": "In corso",
  "bot_exercise_welcome": "Guida introduttiva all'esercizio del chatbot",
  "bot_exercise_restart": "Riavvia il chatbot!",
  "bot_exercise_keyboard_input": "Scrivilo!",
  "bot_exercise_keyboard_input_desc": "Utilizza la tastiera per digitare un messaggio. Se hai bisogno di aiuto con caratteri speciali o desideri aggiungere un'emoji, prova i nostri utili pulsanti.",
  "bot_exercise_voice_input": "Parla!",
  "bot_exercise_voice_input_desc": "Fai clic sul microfono per usare la tua voce ed esercitarti nella pronuncia.",
  "bot_exercise_send_message": "Invia!",
  "bot_exercise_send_message_desc": "Invia un messaggio al chatbot e avvia la conversazione.",
  "bot_exercise_audio_only_mic": "Parla!",
  "bot_exercise_audio_only_mic_desc": "Tocca il microfono per iniziare. Successivamente, parla in modo naturale — Nuala ascolterà e risponderà automaticamente per il resto della conversazione.",
  "roleplay_exercise_welcome": "Guida introduttiva all'esercizio di gioco di ruolo",
  "roleplay_exercise_read_script": "Impara le tue battute!",
  "roleplay_exercise_read_script_desc": "Leggi la conversazione e ascolta come vengono pronunciate le parole.",
  "roleplay_exercise_select_an_actor": "Selezionare il tuo ruolo!",
  "roleplay_exercise_select_an_actor_desc": "Seleziona il ruolo che vorresti interpretare.",
  "roleplay_exercise_start": "Recitalo!",
  "roleplay_exercise_start_desc": "Fai clic su Start e usa la tastiera o la voce per recitare il ruolo che hai scelto.",
  "listening_exercise_welcome": "Guida introduttiva all'esercizio di ascolto",
  "listening_exercise_speak": "Ascolta la frase!",
  "listening_exercise_speak_desc": "Fai clic per ascoltare come viene pronunciata la frase.",
  "listening_exercise_voice_options": "Ascolta una voce diversa!",
  "listening_exercise_voice_options_desc": "Ascolta la frase pronunciata con voci diverse.",
  "listening_exercise_keyboard_input": "Digita la risposta!",
  "listening_exercise_keyboard_input_desc": "Usa la tastiera per digitare la frase che senti.",
  "listening_exercise_word_bank": "Hai bisogno di aiuto?",
  "listening_exercise_word_bank_desc": "Utilizza la banca di parole per selezionare la risposta corretta.",
  "translation_exercise_welcome": "Guida introduttiva all'esercizio di traduzione",
  "translation_exercise_speak": "Ascolta la frase!",
  "translation_exercise_speak_desc": "Fai clic per ascoltare come viene pronunciata la frase.",
  "translation_exercise_read": "Leggi la frase!",
  "translation_exercise_read_desc": "Leggi la frase da tradurre.",
  "translation_exercise_keyboard_input": "Digita la risposta!",
  "translation_exercise_keyboard_input_desc": "Usa la tastiera per digitare la traduzione.",
  "translation_exercise_word_bank": "Hai bisogno di aiuto?",
  "translation_exercise_word_bank_desc": "Utilizza la banca di parole per selezionare la risposta corretta.",
  "pronunciation_exercise_welcome": "Guida introduttiva all'esercizio di pronuncia",
  "pronunciation_exercise_speak": "Ascolta la frase!",
  "pronunciation_exercise_speak_desc": "Fai clic per ascoltare come viene pronunciata la frase.",
  "pronunciation_exercise_read": "Leggi la frase!",
  "pronunciation_exercise_read_desc": "Leggi la frase da pronunciare.",
  "pronunciation_exercise_voice_input": "Pronuncia la frase!",
  "pronunciation_exercise_voice_input_desc": "Fai clic sul microfono per usare la tua voce ed esercitarti nella pronuncia.",
  "exercise_share": "Condividi con altri!",
  "exercise_mute": "Disattiva l'audio!",
  "exercise_skip": "Salta!",
  "exercise_skip_desc": "Vai alla frase successiva, potrai riprovare alla fine.",
  "exercise_restart": "Riavvia!",
  "what_would_you_like_to_do": "Cosa ti piacerebbe fare?",
  "i_want_to_learn": "Voglio imparare...",
  "i_want_to_teach": "Voglio insegnare...",
  "add_alternative_version": "Aggiungi versione alternativa",
  "language_translation_helper_text": "Premere il tasto Invio / Ritorno per aggiungere la traduzione.",
  "change_roles": "Cambiare ruolo?",
  "write_your_feedback_here": "Scrivi qui il tuo feedback",
  "yes": "Sì",
  "you_are_human_check": "Conferma di essere una persona",
  "you_will_lose_your_progress_on_this_exercise": "Perderai i tuoi progressi in questo esercizio",
  "confirm": "Confermare",
  "general": "Generale",
  "shuffle_phrases": "Frasi in ordine casuale",
  "shuffle_phrases_desc": "Randomizza l'ordine in cui le domande vengono poste negli esercizi.",
  "errors": "Errori",
  "missing_translation": "Traduzione mancante",
  "missing_phrase": "Frase mancante",
  "invalid_image_domain": "L'URL dell'immagine deve provenire da un dominio Nualang approvato",
  "row": "Riga",
  "no_valid_type": "Il tipo deve essere 'actor' o 'question'",
  "no_actor_text": "Nessun testo per l'attore",
  "no_actor_number": "L'attore deve avere il numero alla fine, ad es. actor1, actor2",
  "no_question": "Nessuna domanda",
  "no_answers_provided": "Nessuna risposta fornita",
  "no_correct_answer_provided": "Nessun fornitore di risposte corretto",
  "no_answers": "Nessuna risposta",
  "duplicate_topic": "Argomento Duplicato",
  "normal_mode": "Modalità normale",
  "spreadsheet_mode": "Modalità foglio di calcolo",
  "image": "Immagine",
  "delete_selected_row": "Elimina la riga selezionata",
  "crop_image": "Ritaglia l'immagine",
  "crop": "Ritaglia",
  "zoom": "Ingrandisci",
  "rotate": "Ruotare",
  "hide_preview": "Nascondi anteprima",
  "show_preview": "Anteprima dello spettacolo",
  "try_again": "Riprova",
  "confidence_score": "La percentuale di confidenza indica la probabilità che le singole parole siano state riconosciute correttamente.",
  "subscription_plan_teach": "Insegna piano",
  "subscription_plan_teacher_pro": "TEACHER PRO",
  "subscription_plan_basic": "TEACHER Basic",
  "subscription_plan": "Piano di Abbonamento",
  "subscription_status_trialing": "Prova Gratis",
  "subscription_status_active": "Attivo",
  "subscription_status_canceled": "Annullato",
  "subscription_status_undefined": "Gratis",
  "status": "Status",
  "upgrade_plan": "Fare Upgrade di Piano",
  "manage_plan": "Gestire Piano",
  "cancel_plan": "Annulla Piano",
  "your_plan": "Il Tuo Piano",
  "plan_cost": "Costa di Piano",
  "next_billing_date": "Data fatturazione",
  "free": "Gratis",
  "payment_method": "Metodo di Pagamento",
  "pricing_page_title": "Selezionare il tuo piano",
  "pricing_page_subtitle": "Piani di pricing per docenti, scuoli e comuni.",
  "pricing_page_testimonials_title": "La voci dei docenti",
  "compare_plans": "Visualizza piani",
  "features": "Funzionalità",
  "upgrade_submit": "Upgrade",
  "upgrade_subscription_desc": "Per accedere a questa funzionalità, necessario fare l'upgrade dell'account. Clicca Upgrade per scoprire altri piani.",
  "upgrade_plan_explanation": "Per accedere a questa funzionalità, necessario fare l'upgrade dell'account",
  "upgrade_subscription_student": "Questa funzionalità solo disponible per insegnanti.",
  "public_visibility_disabled_wayside": "Le classi sono gestite da Wayside Publishing e devono rimanere private.",
  "public_visibility_disabled_loading": "Stiamo ancora verificando il tuo abbonamento. Aggiorna la pagina se la situazione non cambia.",
  "public_visibility_disabled_trial": "Le classi pubbliche non sono disponibili durante la prova gratuita. Passa a un piano a pagamento per rendere pubblica questa classe.",
  "creator_not_subscribed": "Questo contenuto non è disponible perche l'untente non è attualmente abbonato.",
  "first_name": "Nome",
  "last_name": "Cognome",
  "role": "Ruolo",
  "school_name": "Scuola",
  "school_district": "Provincia?",
  "city": "Città",
  "state": "Comune",
  "send_message": "Invia Messaggio",
  "sign_me_up": "Iscrivimi!",
  "free_trial": "Prova GRATIS?",
  "interactive_demo": "Demo Interattivo ",
  "news_and_updates": "novità e aggiornamenti",
  "teacher": "Docente",
  "principal": "Direttore",
  "tutor": "Tutore",
  "parent": "Gentitore",
  "student": "Studente",
  "other": "Altro",
  "none": "Nessuno",
  "group_subscription_plans": "Piani di abbonamenti di gruppo",
  "group_plan": "Piano di gruppo",
  "leave_group": "Abbandonare il gruppo",
  "joined_subscription": "Si è iscritto",
  "joined_subscription_desc": "Benvenuto al gruppo {{groupName}}, ora stai utilizzando Teacher PRO!",
  "unable_to_join_subscription": "Impossible registrarsi",
  "unable_to_join_subscription_desc": "Si è verificato un problema nella registrazione, si prega di riprovare più tardi",
  "unable_to_join_subscription_invalid_email_desc": "Non è possibile accedere a questo gruppo senza uno dei domini e-mail consentiti: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' ha raggiunto il limite di membri, contattare l'amministratore del gruppo per aumentare il limite.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Immagine Bloccata?",
  "recommended_courses": "Corsi Consigliati",
  "subscription_status_trialing_expired": "Prova gratuita scaduta",
  "no_public_content_created": "Nessun contenuto pubblico creato",
  "add_tag": "Premere Invio / Ritorno per aggiungere un tag",
  "add_collaborator_tag": "Premere Invio / Ritorno per aggiungere un collaboratore",
  "add_to_classroom": "Aggiungere all'aula",
  "add_to_classroom_desc": "Add '{{courseName}}' to {{classroomNames}}.",
  "change_voice_speed": "Modificare la velocità della voce",
  "extra_fast": "Massima velocità",
  "fast": "Parlatore molto veloce",
  "medium": "Velocità normale",
  "slow": "Rallentalo un po'",
  "extra_slow": "Una parola alla volta",
  "card_ALL": "Tutto",
  "join_classroom_to_access": "Accedere all'aula per partecipare",
  "join_course_to_access": "Accedere al corso per partecipare",
  "confidence": "Fiducia",
  "teach_lang": "Voglio insegnare",
  "write_feedback": "Scrivere Feedback",
  "allowed_domains": " domini scolastici consentiti (opzionale)",
  "add_allowed_domains_desc": "Limitare l'accesso in base al dominio scolastico e.g 'schooldomain.com'",
  "send_feedback": "Inviare Feedback",
  "add_feedback": "Aggiungere Feedback",
  "feedback_content": " Contentuto del Feedback",
  "report_problem": "Segnalare problema",
  "report_problem_input_label": "Descrizione del problema",
  "update_feedback": "Aggiorna Feedback",
  "student_completes_exercise": "Quando uno studente completa un esercizio",
  "delete_feedback_confirmation": "Sei sicuro di voler cancellare questo feedback?",
  "delete_feedback": "Cancella Feedback",
  "updates_to_our_terms_of_service": " Aggiornamenti ai nostri Termini di servizio",
  "email_me_when": "Scrivimi quando:",
  "new_classroom": "Aula nuova",
  "student_progress": "Progresso dello studento",
  "view_course": "Vedere corso",
  "view_section": "Vedere Sezione",
  "classroom_members_not_found_title": "Non ci sono ancora membri",
  "classroom_members_not_found_desc": "Questa aula non ha ancora nessun membro",
  "open_topic": "Tema aperto",
  "click_to_speak": "clicca per parlare",
  "click_to_stop": "clicca per interrompere",
  "listening_indicator": "Ascoltando...",
  "save_recording_to_report": "Salvare la registrazione in un rapporto",
  "no_voice_recording_saved": "La registrazione vocale non è stata salvata",
  "classrooms_not_created": "No classrooms selectable",
  "select_a_classroom": "Selezionare una aula.",
  "voice_attempt": "Tentativo di voce.",
  "upload_variables": "Upload variables",
  "next_game": "Next Game",
  "roleplay_games": "Roleplay Games",
  "roleplay_games_description": "Click on one of the cards below to play a specific game",
  "choose_game_mode": "Choose a game mode",
  "story": "Story",
  "story_description": "Listen to the conversation between the characters and answer questions to test your understanding.",
  "fill_in_blanks": "Fill in the blanks",
  "fill_in_blanks_description": "Can you correctly identify what's missing?",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "act_it_out": "Act it out",
  "act_it_out_description": "Can you select the correct response?",
  "act_it_out_listening": "Act it out - Listening",
  "act_it_out_listening_description": "Use your listening skills to select the correct response.",
  "act_it_out_speaking": "Act it out - Speaking",
  "act_it_out_speaking_description": "Practice your pronunciation by speaking your part.",
  "act_it_out_listening_speaking": "Act it out - Listening and Speaking",
  "act_it_out_listening_speaking_description": "Practice your pronunciation by speaking your part.",
  "select_role": "Select your role",
  "select_role_description": "Select the role you would like to play.",
  "mute": "Mute",
  "unmute": "Unmute",
  "replay": "Restart",
  "restart": "Restart",
  "group_courses": "Group courses",
  "select": "Select",
  "classroom_creator_welcome": "Getting started with your classroom",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "classroom_creator_add_courses": "Add courses",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "classroom_creator_add_students_email": "Invite students",
  "classroom_creator_track_progress": "Track student activity",
  "classroom_creator_track_progress_desc": "Once students have joined the classroom, click to view their progress on the courses which have been added.",
  "forLang_and_learnLang_the_same": "Learn language and speaker language are the same. Translation exercise is disabled as a result",
  "english": "Inglese",
  "french": "Francese",
  "german": "Tedesco",
  "irish": "Irlandese",
  "italian": "Italiano",
  "portuguese": "Portoghese",
  "spanish": "Spagnolo",
  "close": "Chiudere",
  "last": "Termine",
  "classroom": "Classe",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Roleplay",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full roleplay script",
  "sort": "Sort",
  "sort_by": "Ordina per",
  "newest": "Più recente",
  "alphabetical": "Alfabetico",
  "recently_changed": "Modificato di recente",
  "recently_viewed": "Visualizzato di recente",
  "oldest": "Meno recenti",
  "default": "Predefinito",
  "clear_filters": "Cancella filtri",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Carta",
  "banner": "Bandiera",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Ascolta e Parla",
  "audio_only_tooltip": "Passa alla modalità solo audio",
  "switch_to_text": "Passa al testo",
  "switch_to_text_tooltip": "Torna alla modalità testo",
  "audio_only_title": "Parla con {{botName}}",
  "audio_only_subtitle": "Una conversazione interamente parlata, senza testo. Cuffie consigliate.",
  "audio_only_mode_unavailable_fallback_chat": "Questo esercizio richiede la modalità Ascolta e parla, ma non è disponibile su questo dispositivo: si continuerà in modalità Chat.",
  "microphone_ready": "Microfono pronto",
  "bot_is_speaking": "Sta parlando...",
  "thinking_indicator": "Sto pensando...",
  "start_conversation": "Inizia la conversazione",
  "stop_button_label": "Ferma",
  "stop_bot_message": "Ferma la voce del chatbot",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Digita o pronuncia le tue risposte, poi leggi o ascolta le risposte del bot.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Riascolta",
  "replay_bot_message": "Ripeti il messaggio del chatbot",
  "you": "Tu",
  "ready_when_you_are": "Pronto quando vuoi",
  "bot_speaking_banner": "{{botName}} sta parlando",
  "listening_to_you": "Ti sto ascoltando",
  "bot_thinking_banner": "{{botName}} sta pensando",
  "one_moment": "Un momento",
  "listen_first": "Ascolta prima",
  "tap_when_done": "Tocca quando hai finito",
  "conversation_complete": "Conversazione completata",
  "exchanges_label": "Scambi",
  "time_spoken_label": "Tempo parlato",
  "review_your_turns": "Rivedi i tuoi turni",
  "submit_to_teacher": "Invia all'insegnante",
  "great_job": "Ottimo lavoro!",
  "or": "or",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Ciao il mio nome è {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "exercise_progress_bar": "Exercise progress bar",
  "page": "Page",
  "unknown": "Sconosciuto",
  "add_a_discussion_topic": "Aggiungi un Argomento di Discussione",
  "add_a_discussion_prompt": "Aggiungi un Prompt di Discussione",
  "add_a_url_for_students_to_discuss": "Aggiungi un URL per la Discussione degli Studenti",
  "images_that_students_can_use_as_a_background_during_the_call": "Immagini che gli Studenti Possono Usare come Sfondo Durante la Chiamata",
  "discussion_images": "Immagini di Discussione",
  "images_for_students_to_discuss_during_the_call": "Immagini per gli Studenti da Discutere Durante la Chiamata",
  "recording_time": "Tempo di Registrazione",
  "due_date": "Data di Scadenza",
  "interculturarity": "Interculturalità",
  "comprehensibility": "Comprensibilità",
  "function_and_text_type": "Funzione e Tipo di Testo",
  "vocabulary_in_context": "Vocabolario nel Contesto",
  "Drag_and_drop_image_from_your_computer": "Trascina e Rilascia un'Immagine dal Tuo Computer",
  "record_time_limit": "Limite di Tempo di Registrazione",
  "schedule_discussion_options": "Opzioni di Pianificazione delle Discussioni",
  "chat_options": "Opzioni di Chat",
  "recording_info": "Submission Info",
  "discussion_id": "ID Discussione",
  "discussion_prompt": "Prompt di Discussione",
  "attendees": "Partecipanti",
  "created_discussions": "Discussioni Create",
  "create_groups": "Gruppen erstellen",
  "select_all": "Alles auswählen",
  "remove_group": "Gruppe Entfernen",
  "grouped_discussions": "Discussioni Raggruppate",
  "no_recordings_found": "Nessuna Registrazione Trovata",
  "recordings": "Registrazioni",
  "scheduled_meetings": "Riunioni Pianificate",
  "no_meetings_scheduled": "Nessuna Riunione Pianificata",
  "discussion_info": "Informazioni sulla Discussione",
  "invites": "Inviti",
  "invited_members": "Membri Invitati",
  "minute": "Minuto",
  "feedback": "Feedback",
  "view": "Vista",
  "no_data_found": "Nessun Dato Trovato",
  "no_past_discussions_found": "Nessuna Discussione Passata Trovata",
  "no_submissions_found": "Nessuna Sottomissione Trovata",
  "no_scheduled_discussions_found": "Nessuna Discussione Pianificata Trovata",
  "view_more": "Visualizza Altro",
  "past": "Passato",
  "submissions": "Invii",
  "background_images": "Immagini di Sfondo",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Medaglie di gioco dal vivo",
  "live_game_medals_description": "Sblocca medaglie classificandoti 1°, 2° o 3° durante un gioco dal vivo",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "Nessuna conversazione disponibile",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Valutazione delle prestazioni di Nuala",
  "using_nuala_performance": "Se si utilizza la Valutazione delle prestazioni di Nuala, si perderanno tutte le valutazioni create manualmente.",
  "are_you_sure_nuala_performance": "Sei sicuro di voler utilizzare la Valutazione delle prestazioni di Nuala?",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Discussione Creata",
  "discussion_updated": "Discussione aggiornata",
  "give_feedback": "Fornisci Feedback",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Nessuna discussione trovata",
  "no_discussions_found_desc": "Tutte le discussioni e le presentazioni possono essere trovate qui",
  "quality_of_interaction": "Qualità dell'Interazione",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Discutere",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Fornisce feedback a tutti i membri del gruppo di discussione. Non è possibile fornire feedback di gruppo e individuali a uno studente contemporaneamente.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Informazioni sulla griglia di valutazione",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Modelli di Discussione",
  "discussion_templates_desc": "Usa uno dei nostri modelli di discussione predefiniti, qui per aiutarti a creare contenuti per i tuoi studenti",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Guida alle Discussioni",
  "discuss_scheduled_discussions": "Discussioni Programmate",
  "discuss_scheduled_discussions_desc": "Qui troverai le discussioni programmate dall'insegnante. Potrai unirti a queste discussioni e parlare di un argomento con altri studenti del tuo gruppo.",
  "discuss_refresh_discussions": "Aggiorna Discussioni",
  "discuss_refresh_discussions_desc": "Questo pulsante ti permetterà di aggiornare per ottenere le ultime discussioni programmate.",
  "discuss_recorded_discussions": "Registra Discussioni",
  "discuss_recorded_discussions_desc": "Qui puoi trovare le discussioni che hai registrato e inviato per la revisione dell'insegnante. Una volta ricevuti i feedback, potrai visualizzarli.",
  "discuss_grouped_discussions": "Discussioni Raggruppate",
  "discuss_grouped_discussions_desc": "Qui puoi trovare tutte le discussioni che hai creato per i tuoi studenti basate sul nome dell'argomento. Clicca su una discussione raggruppata per vedere quali gruppi di studenti sono stati creati.",
  "discuss_submissions": "Sottomissioni delle Discussioni",
  "discuss_submissions_desc": "Qui puoi trovare le sottomissioni delle discussioni registrate create da gruppi di studenti. Puoi visualizzare la loro registrazione, così come la trascrizione delle discussioni e dare feedback individuali o di gruppo.",
  "refresh_discuss": "Aggiorna Discussione",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Valutazioni delle prestazioni",
  "attended": "Presente",
  "did_not_attend": "Non ha partecipato",
  "discussion_attendance": "Partecipazione alle discussioni",
  "submitted_recordings": "Registrazioni inviate",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Aggiungi una versione alternativa della frase da contrassegnare come corretta, ad esempio 'You are welcome' potrebbe essere un'alternativa a 'You're welcome'",
  "upload_video": "Carica Video",
  "select_video_desc": "Trascina e rilascia un video dal tuo computer",
  "add_video": "Aggiungi Video",
  "video_info": "Video del Corso",
  "play_video": "Riproduci Video",
  "delete_video": "Elimina Video",
  "delete_video_confirmation": "Sei sicuro di voler eliminare questo video?",
  "view_video": "Guarda il Video",
  "video_options": "Opzioni Video",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Rimuovi domanda",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "close_drawer": "Close Drawer",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "incomplete_translation": "There is still more to this sentence!",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ucraino",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Si è verificato un errore durante la ricerca, riprova",
  "create_feedback_error": "Si è verificato un errore durante la creazione del feedback, riprova",
  "get_recs_error": "Si è verificato un errore durante l'ottenimento delle registrazioni",
  "get_image_error": "Si è verificato un errore durante l'ottenimento delle immagini",
  "update_discussion_error": "Si è verificato un errore durante l'aggiornamento della discussione, riprova",
  "invite_users_error": "Si è verificato un errore durante l'invito degli utenti, riprova",
  "create_image_error": "Si è verificato un errore durante il caricamento dell'immagine, riprova",
  "grade_conversation_error": "Si è verificato un errore durante la valutazione della conversazione, riprova",
  "get_transcript_error": "Si è verificato un errore durante l'ottenimento della trascrizione, riprova",
  "get_subs_error": "Si è verificato un errore durante l'ottenimento delle consegne, riprova",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Si è verificato un errore durante la programmazione della discussione, riprova",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Lo studente ha modificato manualmente questa trascrizione dopo la registrazione.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Non ci sono corsi condivisi tra le classi selezionate.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Ciao",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Correzione linguistica",
  "correction_original": "Originale",
  "correction_suggested": "Suggerimento",
  "language_corrections_to_review": "Correzioni linguistiche da rivedere",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Impostazioni a livello utente",
  "chatbot_dynamic_responses": "Chatbot - Risposte dinamiche",
  "chatbot_dynamic_responses_desc": "Se la risposta dinamica è attivata, il Chatbot ascolterà e si adatterà attivamente, chiedendo maggiori dettagli, una formulazione più chiara o risposte realistiche, invece di passare semplicemente al prompt successivo predefinito.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "La trascrizione qui sotto richiede la tua revisione.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Uno studente si comporta in modo inappropriato durante un esercizio con il Chatbot",
  "ai_chatbot_error_response": "Mi dispiace, ho commesso un errore nella mia risposta. Riprova!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Se sei umano, lascia questo campo vuoto",
  "progress": "Progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Significato - Ascolta e Parla",
  "meaning_listen_and_speak_exercise_desc": "Ascolta la definizione e parla la frase corretta.",
  "meaning-read-and-write": "Significato - Leggi e Scrivi",
  "select_the_correct_phrase": "Seleziona la frase corretta per questa definizione",
  "chinese": "Cinese",
  "custom_feedback_placeholder": "Opzionale: aggiungi istruzioni aggiuntive per focalizzare il feedback (ad es. accuratezza, complessità o uso delle strutture target).",
  "generate_feedback_view_the": "Visualizza la",
  "generate_feedback_rubric_name": "Rubrica di Crescita Analitica",
  "generate_feedback_rubric_desc": "i criteri utilizzati nel nostro feedback AI.",
  "late_submission": "Consegna in Ritardo",
  "days_late_one": "{{count}} giorno di ritardo",
  "days_late_other": "{{count}} giorni di ritardo",
  "phrase_definition": "Definizione della frase",
  "phrase_definition_helper_text": "Premere il tasto Invio / Ritorno per aggiungere la definizione.",
  "generate_definitions": "Genera definizioni",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Liste di frasi",
  "no_phrase_lists": "Nessuna lista di frasi",
  "all_phrase_lists": "Tutte le liste di frasi",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Si è verificato un problema durante la generazione delle definizioni. Riprova.",
  "saving_defintions_error": "Si è verificato un problema durante il salvataggio delle definizioni. Riprova.",
  "auto_generate_definitions": "Genera definizioni",
  "generating_definitions": "Generazione definizioni",
  "definitions": "Definizioni",
  "view_phrase_list": "Visualizza elenco frasi",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Copia in",
  "transfer": "Copia",
  "create_phrase_list_from_selection": "Crea nuovo elenco frasi",
  "no_other_phrase_lists": "Nessun altro elenco di frasi",
  "add_row": "Aggiungi riga",
  "problem_updating": "Si è verificato un problema durante l'aggiornamento",
  "exercise_settings": "Impostazioni esercizi",
  "excercise_voice": "Voce dell'esercizio",
  "excercise_voice_desc": "Selezionare la voce che verrà utilizzata negli esercizi per questo elenco di frasi.",
  "excercise_visibility": "Visibilità degli esercizi",
  "keyboard": "Tastiera",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Benvenuto nell'esercizio Leggi e Scrivi",
  "read_write_exercise_definition": "Definizione",
  "read_write_exercise_definition_desc": "Leggi la definizione mostrata qui",
  "read_write_exercise_options": "Digita la frase",
  "read_write_exercise_options_desc": "Digita la frase corretta nella casella di testo",
  "read_the_definition": "Leggi la definizione",
  "type_the_correct_phrase": "Digita la frase corretta",
  "read_write": "Leggi e Scrivi",
  "meaning_read_write": "Significato - Leggi e Scrivi",
  "meaning_read_write_exercise_desc": "Leggi la definizione e digita la frase corretta.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Crea chatbot",
  "find_chatbot": "Trova chatbot",
  "find_chatbots": "Trova chatbot",
  "add_chatbot": "Aggiungi chatbot",
  "add_chatbots": "Aggiungi chatbot",
  "template": "Modello",
  "chatbot_name": "Nome del chatbot",
  "create_scenario": "Crea un gioco di ruolo",
  "find_scenario": "Trova un gioco di ruolo",
  "find_scenarios": "Trova giochi di ruolo",
  "scenario_name": "Nome del gioco di ruolo",
  "scenarios_added": "Giochi di ruolo aggiunti all'argomento",
  "chatbots_added": "Chatbot aggiunti all'argomento",
  "add_scenarios": "Aggiungi giochi di ruolo",
  "achievements": "Risultati",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Trova argomenti creati da altri insegnanti nella scheda <1>Comunità</1>.",
  "chatbot_title": "Titolo del Chatbot",
  "open_ended": "Aperto",
  "open_ended_desc": "Lascia che i tuoi studenti rispondano con le loro stesse parole.",
  "quiz": "Quiz",
  "quiz_desc": "Guida lo studente attraverso una serie di domande.",
  "picture_quiz": "Quiz con immagini",
  "picture_quiz_desc": "Poni domande in base alle immagini.",
  "emoji_quiz": "Emoji Quiz",
  "emoji_quiz_desc": "Indovina la risposta in base alle emoji.",
  "quiz_style_templates": "Modelli in stile quiz",
  "no_scenarios_found": "Nessun gioco di ruolo trovato",
  "no_chatbots_found": "Nessun chatbot trovato",
  "use_voice": "Usa la voce",
  "internal_view_provider_marks": "Vista interna · Voti del fornitore visibili",
  "legacy": "Precedente",
  "scan_to_open_the_classroom": "Scansiona per aprire la classe",
  "classroom_link": "Link della classe",
  "copy": "Copia",
  "tell_students_to": "Chiedi agli studenti di",
  "invite_step_sign_in": "Accedere al proprio account.",
  "invite_step_scan": "Scansionare il codice o aprire la classe.",
  "invite_step_tap_join": "Toccare {{button}}.",
  "select_exercise_phrases_intro": "Seleziona le liste di frasi che vuoi usare. Puoi combinare liste di corsi diversi.",
  "select_exercise_scenarios_intro": "Scegli uno scenario da giocare dal vivo con la classe.",
  "source_type_phrase_lists": "Liste di frasi",
  "source_type_scenarios": "Scenari",
  "clear_all": "Cancella tutto",
  "n_of_m_lists_selected": "{{n}} di {{m}} liste selezionate",
  "n_phrase_lists": "{{count}} liste di frasi",
  "n_phrases": "{{count}} frasi",
  "has_definitions": "con definizioni",
  "n_scenarios": "{{count}} scenari",
  "n_messages": "{{count}} messaggi",
  "n_interactions": "{{count}} interazioni",
  "lists_and_phrases_selected": "{{lists}} liste · {{phrases}} frasi",
  "no_lists_selected": "Nessuna lista selezionata",
  "no_scenario_selected": "Nessuno scenario selezionato",
  "scenario_selected": "Scenario selezionato",
  "number_of_messages": "Numero di messaggi",
  "max_phrases_label": "Max",
  "max_phrases_all": "Tutte le {{count}}",
  "estimated_game_time_hint": "{{questions}} domande da {{seconds}}s ciascuna, più il feedback tra un round e l'altro.",
  "n_minutes": "{{count}} minuti",
  "live_game_title": "{{exercise}} · {{count}} liste di frasi",
  "phrases_from": "Frasi da",
  "source_card_meta": "{{topic}} · {{count}} frasi",
  "n_more": "altri",
  "waiting_for_students": "In attesa che gli studenti si uniscano.",
  "how_students_answer": "Come rispondono gli studenti",
  "answer_keyboard_and_word_bank": "Tastiera e banca di parole",
  "answer_keyboard_and_word_bank_hint": "Gli studenti scrivono, con le tessere di parole come alternativa.",
  "answer_keyboard_only": "Solo tastiera",
  "answer_keyboard_only_hint": "Più difficile — gli studenti digitano l'intera risposta.",
  "answer_word_bank_only": "Solo banca di parole",
  "answer_word_bank_only_hint": "Più facile — gli studenti toccano le parole per posizionarle.",
  "time_per_question": "Tempo per domanda",
  "all_n_phrases": "Tutte le {{count}} frasi",
  "includes_one_from_each_list": "È sempre inclusa almeno una frase per ogni lista selezionata.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "Tutte le lingue",
  "all_levels": "Tutti i livelli",
  "novice": "Principiante",
  "intermediate": "Intermedio",
  "advanced": "Avanzato",
  "popular": "Popolare",
  "courses_shared_by_other_teachers": "Corsi condivisi da altri insegnanti",
  "no_created_courses_match": "Nessun corso creato corrisponde a questi filtri",
  "no_joined_courses_match": "Nessun corso a cui hai aderito corrisponde a questi filtri",
  "no_community_courses_match": "Nessun corso corrisponde a questi filtri",
  "courses_added": "Corsi aggiunti",
  "problem_adding_courses": "C'era un problema nell'aggiungere questi corsi",
  "search_topics_placeholder": "Cerca argomenti",
  "search_classrooms_placeholder": "Cerca aule",
  "search_student_name": "Cerca nome studente",
  "search_sections_and_topics": "Cerca sezioni e argomenti",
  "clear_search": "Cancella ricerca",
  "x_of_y": "{{shown}} di {{total}}",
  "outline_filter_count": "{{topics}} in {{sections}}",
  "topic_count_one": "{{count}} argomento",
  "topic_count_other": "{{count}} argomenti",
  "section_count_one": "{{count}} sezione",
  "section_count_other": "{{count}} sezioni",
  "no_sections_or_topics_match": "Nessuna sezione o argomento corrisponde",
  "try_different_keyword_or_difficulty": "Prova un'altra parola chiave o un'altra difficoltà.",
  "nothing_matches_keyword_at_difficulty": "Nessun risultato per “{{keyword}}” con difficoltà {{difficulty}}. Prova un'altra parola chiave o un'altra difficoltà.",
  "session_feedback": "Il tuo feedback",
  "session_feedback_preparing": "Stiamo preparando il tuo feedback…",
  "session_feedback_unavailable": "Il tuo feedback non è disponibile al momento.",
  "suggested_level": "Livello suggerito",
  "session_report": "Feedback sulla conversazione",
  "view_full_report": "Visualizza feedback completo",
  "rating_approaching": "In avvicinamento",
  "rating_meets": "Raggiunto",
  "rating_exceeds": "Superato",
  "area_of_strength": "Punto di forza",
  "area_for_growth": "Area di miglioramento",
  "rating_not_yet": "Non ancora",
  "session_report_short_interaction": "Interazione",
  "session_report_short_vocabulary": "Vocabolario",
  "session_report_short_function": "Funzione",
  "session_report_strength": "Punto di forza",
  "session_report_growth": "Miglioramento",
  "ai_generated_report": "Feedback generato dall'IA",
  "ai_generated_report_tooltip": "Generato dall'IA solo da questa sessione. Il livello suggerito e le valutazioni sono stime, non una collocazione definitiva.",
  "session_report_new": "Nuovo",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} messaggi",
  "chatbot_message_count_one": "{{count}} messaggio",
  "chatbot_message_count_other": "{{count}} messaggi",
  "attempt_count": "{{count}} tentativi",
  "attempt_count_one": "{{count}} tentativo",
  "attempt_count_other": "{{count}} tentativi",
  "of_total_correct": "su {{total}} corrette",
  "attempts_to_review": "Tentativi da rivedere",
  "attempts_not_shown": "{{items, list}}: tentativi non mostrati",
  "count_correct": "{{count}} corretti",
  "count_incorrect": "{{count}} errati",
  "count_skipped": "{{count}} saltati",
  "count_partially_correct": "{{count}} parzialmente corretti",
  "view_all_count": "Vedi tutti i {{count}}",
  "view_attempt": "Vedi tentativo",
  "scenario_description_default": "Questo è uno scenario per aiutare gli studenti a parlare {{learnLang}} con sicurezza."
}
